export const validationMessage = {
  /* add/edit people */
  firstNameReq: 'Please enter First Name.',
  firstNameValid: 'Please enter a valid First Name.',
  NameValid: 'Please enter a valid  Name.',
  middleNameValid: 'Please enter a valid Middle Name.',
  suffixValid: 'Please enter a valid Suffix',
  lastNameReq: 'Please enter Last Name.',
  lastNameValid: 'Please enter a valid Last Name.',
  phoneReq: 'Please enter Phone Number.',
  phone1CodeValid: 'Please enter a valid Country Code.',
  phone1NoandCodeValid: 'Please enter valid Country Code and Phone 1.',
  phoneValid: 'Please enter a valid Phone 1.',
  phone2CodeValid: 'Please enter a valid Country Code.',
  phone2NoandCodeValid: 'Please enter valid Country Code and Phone 2.',
  phone2Valid: 'Please enter a valid Phone 2.',
  phoneOnlyReq: 'Please enter Phone.',
  phoneOnlyCodeValid: 'Please enter a valid Country Code.',
  phoneOnlyNoandCodeValid: 'Please enter valid Country Code and Phone.',
  phoneOnlyValid: 'Please enter a valid Phone.',
  emailReq: 'Please enter an email address.',
  emailValid: 'Please enter a valid Email.',
  addressReq: 'Please enter Address.',
  addressValid: 'Please enter a valid Address 1.',
  address2Valid: 'Please enter a valid Address 2.',
  cityReq: 'Please enter City.',
  cityValid: 'Please enter a valid City.',
  stateReq: 'Please select State.',
  countryReq: 'Please select Country.',
  zipReq: 'Please enter Zip.',
  ZipValid: 'Please enter a valid Zip.',
  reviewerValid: 'Please select Reviewer.',
  dobReq: 'Please select Date Of Birth.',
  identifiedGenderReq: 'Please select Identified Gender.',
  bioGenderReq: 'Please select Bio Gender.',
  primaryLanguageReq: 'Please select Primary Language.',
  preferedLanguageReq: 'Please select Prefered Language.',
  identifierIdReq: 'Please enter Identifier ID.',
  ethinicityReq: 'Please select Race/Ethnicity.',
  relationShipReq: 'Please select Relationship.',
  helperReq: 'Please select Helper.',
  collaborationReq: 'Please select Collaboration.',
  abbreviationValid: 'Please enter a valid Abbreviation.',
  passwordReq: 'Please enter Password.',
  suffixsValid: 'Please enter a valid Suffix',
  identificationNumberValid:"Please enter a valid identifier ID",
  identifierIdValue:"Please enter a identifier ID",
  identificationTypeValid:"Please enter a identifier type",
  newPasswordReq: 'Please enter New Password.',
  confirmPasswordReq: 'Please enter Confirm Password.',
  passwordMustMatch: 'Passwords must match.',
  newPwdValid: 'Password must contain at least 6 characters, including one uppercase, one lowercase, one digit and one symbol.',

  /* agency */
  agencyReq: 'Please enter a valid Agency Name.',
  contactFirstNameReq: 'Please enter a valid Contact First Name.',
  contactLastNameReq: 'Please enter a Valid Contact Last Name.',
  abbrevReq: 'Please enter an Abbreviation.',

  /* Helper */
  titleReq: 'Please select Title.',
  roleReq: 'Please select Role.',
  agencySelectReq: 'Please select Agency.',
  supervisorReq: 'Please select Supervisor.',
  managerReq: 'Please select Manager.',

  /*Collaboration*/
  startDateReq: 'Please select Start Date.',
  endDateReq: 'Please select End Date.',
  startDateVal: 'Please enter a Date on or after ',
  endDateVal: 'Please enter a Date between the ',
  typeReq: 'Please select Type.',
  levelReq: 'Please select Level.',
  codeValid: 'Please enter a valid  Code.',
  leadReq: 'Please select Lead.',
  questionnaireReq: 'Please select Questionnaire.',
  descriptionReq: 'Please enter a valid Description.',
  delteConfirm: 'Are you sure you want to delete?',
  categoryReq: 'Please select Category.',
  categoryDuplicateValid: 'Cannot add duplicate categories.',
  leadOneReq: 'Please select at least one Lead.',
  collaborationOneReq: 'Please add at least one Collaboration.',
  supportOneReq: 'Please select at least one support as current.',
  primaryOneReq: 'Please select at least one Primary.',
  dateError: 'Please enter a valid End Date',
  endDateError: 'End Date can only be set to today’s date. No future dates are supported at this time',
  starDateError: 'Please enter a valid Start Date',
  dobError: 'Please enter a valid Date of Birth',
  HelperError: 'Current helper is required.',
  AccessReq: 'Please enter a valid Access.',
  AgencyReq: 'Please enter a valid Agency.',
  CollaborationReq: 'Please enter a valid Collaboration.',
  leadEndDate: 'Cannot save collaboration without a current lead.',

  // options unit
  listOrderReq: 'Please enter List Order.',
  abbreviationDuplication: 'Abbreviation already exist.',
  listOrderValid: 'Please enter a valid List Order',
  alertTypeMsg: 'Please select an Alert Type',
  duplicateName: 'Name already exists.',
  duplicateListOrder: 'List order already exists.',

  /* questionnaire */
  alertnotificationReq: 'Alert Notification Type is required.',
  ruleReq: 'Please enter a valid Alert Name.',
  ruleNameReq: 'Please enter a valid Rule Name.',
  ruleLevelReq: 'Please select Rule Level.',
  questionReq: 'Please select Question.',
  operatorReq: 'Please select Operator.',
  valueReq: 'Please enter a Value.',
  joinByReq: 'Please select Join By.',
  nameReq: 'Please enter a valid Name.',
  externalNameReq: 'Please enter a valid External Name.',
  externalDescriptionReq: 'Please enter a valid External Description.',
  otpReq:  'Please enter a valid Verification Code.',
  reasonReq: 'Please select a Reason.',
  voiceReq: 'Please select a Voice Type.',
  noteReq: 'Please enter a Note.',
  noteTextValid: 'Please enter a valid note.',
  itemnoteReq: 'Please enter a Note.',
  assessmentQuestionValidationReq: 'Please answer all the questions.',
  QuestionnaireNameReq: 'Please enter a valid Questionnaire Name',
  eventnoteReq: 'Please enter Event Note.',
  eventdateReq: 'Please enter a valid Event Date.',
  assesmentdateReq: 'Please enter a valid Date.',
  dateBeforeError: 'Please select a date on or before assessment date.',
  currentPrimaryCollabReq: 'Please select at least one current collaboration as Primary.',
  currentLeadReq: 'Please select at least one current helper as Lead.',
  maxThresholdReq: 'Please select a Max Threshold.',
  minThresholdReq: 'Please select a Min Threshold.',
  otpSuccess: 'The OTP has been sent successfully.',
  notesMandatory: 'Please add the appropriate notes for',
  templateDateInvalid:"Please enter a valid date. The date must be today or later.",
  resentLink: "The link has been resent successfully.",

  /* Certification */
  certificateNameReq: 'Please enter Certificate Name.',
  certificateNameValid: 'Please enter a valid Certificate Name.',
  certificateNoReq: 'Please enter Certification Number.',
  certificateNoValid: 'Please enter a valid Certification Number.',
  employeeIdReq: 'Please enter Employee ID.',
  employeeIdValid: 'Please enter a valid Employee ID.',
  certificationTypeReq: 'Please enter Certification Type.',
  certificationTypeValid: 'Please enter a valid Certification Type.',
  certificationStartDateReq: 'Please enter Certification Start Date.',
  certificationStartDateValid: 'Please enter a valid Certification Start Date.',
  certificationExpiryReq: 'Please enter Certification Expiry Date.',
  certificationExpiryValid: 'Please enter a valid Certification Expiry Date.',
  statusReq: 'Please enter Status.',
  statusValid: 'Please enter a valid Status.',
  organizationReq: 'Please enter Organization.',
  organizationValid: 'Please enter a valid Organization.',
};
